import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
import Loading from "../../Shared/components/loading";
import { useGetProviderInfo } from "./BillingInformation.request";
import { PaymentMethodType, PaymentProcessor } from "./Shared/types/PaymentProcessorTypes";
export const BillingInformationContext = createContext({
    clientSecret: undefined,
    setClientSecret: () => { },
    paymentIntentId: undefined,
    setPaymentIntentId: () => { },
    publicKey: undefined,
    setPublicKey: () => { },
    token: undefined,
    setToken: () => { },
    paymentProfileId: undefined,
    setPaymentProfileId: () => { },
    customerCreditCards: undefined,
    setCustomerCreditCards: () => { },
    primaryCreditCard: undefined,
    setPrimaryCreditCard: () => { },
    addedNewCard: false,
    setAddedNewCard: () => { },
    doesPaymentIntentExist: false,
    setDoesPaymentIntentExist: () => { },
    resetContext: () => { },
    customerGiftCards: undefined,
    setCustomerGiftCards: () => { },
    oldGiftCards: undefined,
    setOldGiftCards: () => { },
    enableGiftCards: undefined,
    setEnableGiftCards: () => { },
    authorizeUrl: "",
    paymentProcessor: PaymentProcessor.UNKNOWN,
    setPaymentProcessor: () => { },
    dismissedAddPaymentModal: false,
    setDismissedAddPaymentModal: () => { },
});
export const BillingInformationContextProvider = ({ children }) => {
    const [paymentProcessor, setPaymentProcessor] = useState(PaymentProcessor.UNKNOWN);
    const [clientSecret, setClientSecret] = useState();
    const [paymentIntentId, setPaymentIntentId] = useState();
    const [token, setToken] = useState();
    const [paymentProfileId, setPaymentProfileId] = useState();
    const [publicKey, setPublicKey] = useState();
    const [customerCreditCards, setCustomerCreditCards] = useState();
    const [primaryCreditCard, setPrimaryCreditCard] = useState();
    const [addedNewCard, setAddedNewCard] = useState(false);
    const [doesPaymentIntentExist, setDoesPaymentIntentExist] = useState(false);
    const [customerGiftCards, setCustomerGiftCards] = useState();
    const [oldGiftCards, setOldGiftCards] = useState();
    const [enableGiftCards, setEnableGiftCards] = useState(undefined);
    const [dismissedAddPaymentModal, setDismissedAddPaymentModal] = useState(false);
    const { data, loading, error } = useGetProviderInfo();
    const resetContext = () => {
        setClientSecret(undefined);
        setToken(undefined);
        setPublicKey(undefined);
        setCustomerCreditCards(undefined);
        setPrimaryCreditCard(undefined);
        setPublicKey(undefined);
        setPaymentIntentId(undefined);
        setDoesPaymentIntentExist(false);
        setCustomerGiftCards(undefined);
        setDismissedAddPaymentModal(false);
    };
    if (loading || !data || error) {
        return _jsx(Loading, { error: !!error, text: !!error ? error : undefined, viewportHeight: "75vh" });
    }
    return (_jsx(BillingInformationContext.Provider, Object.assign({ value: {
            clientSecret,
            setClientSecret,
            paymentIntentId,
            setPaymentIntentId,
            publicKey,
            setPublicKey,
            token,
            setToken,
            paymentProfileId,
            setPaymentProfileId,
            customerCreditCards: customerCreditCards === null || customerCreditCards === void 0 ? void 0 : customerCreditCards.filter((c) => c.type !== PaymentMethodType.OFFLINE),
            setCustomerCreditCards,
            primaryCreditCard,
            setPrimaryCreditCard,
            addedNewCard,
            setAddedNewCard,
            doesPaymentIntentExist,
            setDoesPaymentIntentExist,
            resetContext,
            customerGiftCards,
            setCustomerGiftCards,
            oldGiftCards,
            setOldGiftCards,
            enableGiftCards,
            setEnableGiftCards,
            stripePublishableKey: data === null || data === void 0 ? void 0 : data.stripePublishableKey,
            authorizeUrl: data === null || data === void 0 ? void 0 : data.authorizeUrl,
            dismissedAddPaymentModal,
            setDismissedAddPaymentModal,
            paymentProcessor,
            setPaymentProcessor,
        } }, { children: children })));
};
